import React from 'react';
import {Grid, Typography} from "@mui/material";
import useFooterScreenStyles from "../../styles/kozelMeetBoardGame/footer_screen";
import {NavLink} from "react-router-dom";
import {paths} from "../../AppRouters";
import InfoIcon from "@mui/icons-material/Info";
import clsx from "clsx";
import {useAppSelector} from "../../stores/store";

const FooterScreenPreUntold: React.FC = () => {
    const styles = useFooterScreenStyles();
    const { isAuthenticated } = useAppSelector(state => state.auth);
    return (
        <Grid container
              className={clsx(styles.boxContainer,styles.bgLateCream)}
        >
            <Grid item xs={12} lg={6} mt={5}>
                <Typography className={styles.title}>Join Kozel Meet community, create your team which accompanies you at Untold, and participate in the first challenge launched by Kozel!</Typography>
            </Grid>
            <Grid item xs={12} lg={6} mt={5}>
                <Typography className={styles.subtitle}>We guarantee fun and points for you and your team.</Typography>
            </Grid>
            <Grid item xs={12} lg={6} mt={5}>
                <Typography className={styles.subtitle}>Create your account on kozel.ro and discover the challenge!</Typography>
            </Grid>
            {!isAuthenticated && (
                <>
                    <Grid item xs={12} lg={6} mt={5}>
                        <NavLink to={paths.register} className={styles.button}>JOIN THE COMMUNITY</NavLink>
                    </Grid>                    
                </>
            )}
        </Grid>
    );
}

export default FooterScreenPreUntold;
